// components/inventory/IncomingBalanceButton.tsx
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSetRecoilState } from "recoil";
import {
  toastBgState,
  toastMessageState,
  toastShowState,
} from "../../utils/atoms/atoms";
import { createIncomingBulkChallan } from "../../api/incoming";

interface IIncomingBalanceButtonProps {
  part_id: number;
  type: "recd";
  party_id: number;
  drawing: string;
  quantity: number;
}

const IncomingBalanceButton = ({
  part_id,
  party_id,
  drawing,
  quantity,
}: IIncomingBalanceButtonProps) => {
  const queryClient = useQueryClient();
  const setToastShow = useSetRecoilState(toastShowState);
  const setToastBg = useSetRecoilState(toastBgState);
  const setToastMessage = useSetRecoilState(toastMessageState);

  const balanceMutation = useMutation({
    mutationFn: async () =>
      createIncomingBulkChallan({
        action_date: new Date().toISOString(),
        party: { value: party_id },
        part_ids: [{ value: part_id }],
        quantities: `${quantity}`,
        weights: "0",
        remarks: "Balance",
        status: { value: 1 },
      }),
    onSuccess() {
      setToastShow(true);
      setToastBg("success");
      setToastMessage("Balance cleared");
      queryClient.invalidateQueries(["incoming-sent"]);
      queryClient.invalidateQueries(["incoming-recd"]);
      queryClient.invalidateQueries(["incoming-pending"]);
      queryClient.invalidateQueries(["incoming-challan"]);
    },
    onError() {
      setToastShow(true);
      setToastBg("danger");
      setToastMessage("Failed to clear balance");
    },
  });

  const handleClick = () => {
    if (window.confirm(`Mark ${quantity} of "${drawing}" as received?`)) {
      balanceMutation.mutate();
    }
  };

  return (
    <button
      className="btn"
      onClick={handleClick}
      disabled={balanceMutation.isLoading}
      title="Clear balance"
    >
      <i className="bi bi-check2-circle"></i>
    </button>
  );
};

export default IncomingBalanceButton;
